module.exports = __webpack_public_path__ + "mesh-gradient.png?b6dece2e63a6e104f3d2c42b1e1469db";